import axios from 'axios'
const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

const cleanParams = (params: Record<string, any>) =>
  Object.fromEntries(
    Object.entries(params || {}).filter(
      ([, value]) => value !== undefined && value !== null && value !== '' // remove empty string also
    )
  )

export const fetchAccountStatusList = (module: string, params: any) =>
  axios.get(`${API_URL}/account-status/${params?.module_name ?? 'all'}`, {
    params: cleanParams(params),
  })
